<template>
  <div class="login">
    <div class="login-box">
      <h1>Login</h1>
      <el-form :rules="rules" :model="loginForm" status-icon ref="loginForm">
        <el-form-item prop="username">
          <el-input type="text" placeholder="User Name" v-model="loginForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="Password" v-model="loginForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="login">Login</el-button>
        </el-form-item>
        <!-- <p @click="toPassword">Forget Your Password</p> -->
      </el-form>
    </div>
  </div>
</template>

<script>
//引入登录接口
import { api_users_Login, $api_Admin_detail } from "@/api/index";
import shopUrl from "@/api/url";
// 引入local函数
import local from "@/utils/local";
export default {
  data() {
    return {
      shopUrl:shopUrl,
      loginForm: {
        username: "",
        password: ""
      },
      //必填验证
      rules: {
        username: [{ required: true, message: "Please enter an account", trigger: "blur" }],
        password: [{ required: true, message: "Please enter the password", trigger: "blur" }]
      },
      user_id: '',
      service_user_id: '',
      loading: '',
      vin: '',
      url: '',
      s_state: ''
    };
  },
  methods: {
    //修改密码
    toPassword() {
      this.$router.push('/password')
    },
    //登录
    login() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          let res = await api_users_Login({
            username: this.loginForm.username,
            password: this.loginForm.password
          });
          if (res.data.code == 200) {
            //存入身份信息
            local.set("userInfo", res.data.data);
            //存入token值
            local.set("token", res.data.data.token);
            if (res.data.data.role == 4) {
              this.$router.push("/stock");
            } else {
              this.$router.push('/inventory/records')
            }

          }
        }
      });
    },
    async getUserDetail() {
      let res = await $api_Admin_detail({
        user_id: this.user_id,
        service_user_id: this.service_user_id
      })
      if (res.data.code == 200) {
        local.set('userInfo', res.data.data)
        local.set("token", res.data.data.token);
        console.log(this.url,this.vin,this.s_state);
        if (this.vin) {
          this.$router.push({
            path: this.url,
            query: {
              vin: this.vin
            }
          })
        }else if (this.s_state) {
          this.$router.push({
            path: this.url,
            query: {
              s_state: this.s_state
            }
          })
        }else{
          this.$router.push(this.url)
        }
        // this.$router.push('/home')
        this.loading.close();
      } else {
        window.location.href = shopUrl.url+'my-account'
        // this.loading.close();
      }
    }
  },
  created() {
    local.remove('userInfo')
    local.remove('token')
    //接收地址栏参数
    this.user_id = this.$route.query.user_id
    this.service_user_id = this.$route.query.service_user_id
    this.vin = this.$route.query.vin
    this.url = this.$route.query.url
    this.s_state = this.$route.query.s_state
    if (this.user_id && this.service_user_id) {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 1)'
      });
      this.getUserDetail()
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-box {
    height: 300px;
    width: 23.4375vw;

    h1 {
      text-align: center;
      margin-bottom: 50px;
      font-size: 30px;
      font-weight: 700;
    }

    .el-button {
      width: 100%;
      background: #ED3333;
      margin-top: 1.0417vw;
    }

    p {
      font-size: .7292vw;
      text-align: center;
      color: #848484;
      cursor: pointer;
    }
  }
}
</style>